// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__DDNMD","tab":"Sidebar_tab__bED0q","sidebarItemGeneral":"Sidebar_sidebarItemGeneral__bwFf8","sidebarItemFinance":"Sidebar_sidebarItemFinance__nn5zk"};